export const generateEmbeddedIframe = ({
  link,
  width = '100%',
  height = '400px',
  allow = 'camera;microphone',
  title = 'VideoPeel'
}) =>
  `<iframe src="${link}" width="${width}" height="${height}" allow="${allow}" title="${title}"></iframe>`;



// WEBPACK FOOTER //
// ./src/helpers/embediFrameHelper.js